var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',[_c('pie-chart',{attrs:{"library":_vm.chartOptions,"data":_vm.specialty,"colors":_vm.colors,"legend":true,"height":"300px","width":"100%"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }